module.exports = __webpack_public_path__ + "static/img/notificationenable_Step2.a3d186d.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/notificationenable_Step2.png
// module id = 8NrJ
// module chunks = 4